
























import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class Home extends Vue {
  get userName(): string {
    if (this.$store.state.user) {
      return this.$store.state.user.displayName;
    }
    return "";
  }
  get hasUser(): boolean {
    return !!this.$store.state.user;
  }
}
